// extracted by mini-css-extract-plugin
export default {"checkBoxItemsWrapper":"style_checkBoxItemsWrapper__XntLa","btnWrapper":"style_btnWrapper__7PVqJ"};